import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import LoadingButton from '@mui/lab/LoadingButton';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import { useTranslate } from 'src/locales';
import { useAuthContext } from 'src/auth/hooks';
import FormProvider, { RHFTextField, RHFRadioGroup } from 'src/components/hook-form';

// ----------------------------------------------------------------------

type Props = {
  open: boolean;
  onClose: VoidFunction;
  onCreate: (address: any) => void;
};

export default function WithdrawForm({ open, onClose, onCreate }: Props) {
  const { t } = useTranslate();
  const { user } = useAuthContext();
  const WithdrawSchema = Yup.object().shape({
    paymentMethod: Yup.string().required(t('wallet.requiredField')),
    amount: Yup.number().required(t('wallet.requiredField')),
    // pin: Yup.string().required(t('wallet.requiredField')),
    // phoneNumber: Yup.string()
    //   .matches(/^509[0-9]{8}$/, t('wallet.invalidPhoneNumber'))
    //   .required(t('wallet.requiredField')),
  });

  const defaultValues = {
    paymentMethod: 'Moncash',
    amount: 50,
    // pin: '',
    phoneNumber: user?.phone,
  };

  const methods = useForm({
    resolver: yupResolver(WithdrawSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      onCreate(data);
      reset();
      onClose();
    } catch (error) {
      console.error(error);
    }
  });

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>{t('wallet.withdraw')}</DialogTitle>

        <DialogContent dividers>
          <Stack spacing={3}>
            <RHFRadioGroup
              row
              name="paymentMethod"
              options={[
                { label: 'Moncash', value: 'Moncash' },
                // { label: 'Natcash', value: 'Natcash' },
              ]}
            />

            <RHFTextField name="phoneNumber" label={t('auth.phone')} disabled />
            <RHFTextField name="amount" label={t('wallet.amount')} />
            {/* <RHFTextField name="pin" label="Pin" type="password" /> */}
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button color="inherit" variant="outlined" onClick={onClose}>
            {t('wallet.cancel')}
          </Button>

          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            {t('wallet.withdraw')}
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
